











































































































import { Component, Vue } from "vue-property-decorator";
import { Auth } from "aws-amplify";
import FormValidations from "@/helpers/validations";
import { Alert } from "@/models/general";
import { LayoutModule } from "@/store/layout";

@Component
export default class RecoverPassword extends Vue {
  appLogo = require("@/assets/app-logo.png");
  formValidations = new FormValidations();
  loading = false;
  showPassword = false;
  recover = false;

  model = { email: "", code: "", newPassword: "", confirmPassword: "" };

  validate(): void {
    const validForm = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();

    if (validForm) {
      this.recover ? this.submitNewPassword() : this.recoverPassword();
    }
  }

  async recoverPassword(): Promise<void> {
    this.loading = true;
    LayoutModule.cleanAlerts();
    try {
      await Auth.forgotPassword(this.model.email);
      const a: Alert = {
        type: "success",
        text: this.$t("auth.responses.new_code_sended").toString(),
      };
      LayoutModule.setAlerts(a);
      this.recover = true;
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }

  async submitNewPassword(): Promise<void> {
    this.loading = true;
    LayoutModule.cleanAlerts();
    try {
      await Auth.forgotPasswordSubmit(
        this.model.email,
        this.model.code,
        this.model.newPassword
      );
      const a: Alert = {
        type: "success",
        text: this.$t("auth.responses.password_recovered").toString(),
      };
      LayoutModule.setAlerts(a);
      this.$router.push({ name: "login" });
    } catch (error) {
      const e: Alert = {
        type: "error",
        text: this.$t(`auth.responses.${error.name}`).toString(),
      };

      LayoutModule.setAlerts(e);
    } finally {
      this.loading = false;
    }
  }
}
